import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import swal from "sweetalert2";
import { MdThumbUp, MdReply, MdSentimentSatisfied } from "react-icons/md";
import "yet-another-react-lightbox/styles.css";
import {
  FaRegHeart,
  FaHeart,
  FaRegComment,
  FaRegShareSquare,
  FaReply,
} from "react-icons/fa";
import {
  FaBookmark,
  FaRegBookmark,
  FaLink,
  FaEdit,
  FaTrash,
  FaCommentSlash,
} from "react-icons/fa";
import { PiDotsThree } from "react-icons/pi";
import { comment } from "postcss";
import { set } from "date-fns";
import EmojiPicker from "emoji-picker-react";

const EditPost = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [introformData, setIntroFormData] = useState({
    name: "",
    email: "",
    add_name: "",
    gender: "",
    headline: "",
    position: "",
    industry: "",
    website: "",
    country: "",
    city: "",
    summary: "",
    profile_image: "",
    cover_image: "",
  });
  const [postdata, setPostdata] = useState([]);
  const [post, setPost] = useState([]);
  const [likes, setLikes] = useState({});
  const [likedPosts, setLikedPosts] = useState({});
  const [commentlikes, setCommentLikes] = useState({});
  const [commentlikedPosts, setCommentLikedPosts] = useState({});
  const [recievedcomments, setRecievedComments] = useState([]);
  const [showComments, setShowComments] = useState(false);
  const [comments, setComments] = useState({});
  const [initialLikes, setInitialLikes] = useState({});
  const [newComments, setNewComments] = useState({});
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [showLightbox, setShowLightbox] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [replyingTo, setReplyingTo] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const optionsRef = useRef(null);
  const buttonRef = useRef(null);
  const [replyText, setReplyText] = useState("");
  const [isSaved, setIsSaved] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showAllComments, setShowAllComments] = useState(false);
  const [showAllReplies, setShowAllReplies] = useState({});
  const [currentUser, setCurrentUser] = useState({});
  const [showReplyEmojiPicker, setShowReplyEmojiPicker] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [imageModalData, setImageModalData] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const EmojiPickerWrapper = ({ onEmojiSelect, onClose, positionClass }) => {
    const pickerRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (pickerRef.current && !pickerRef.current.contains(e.target)) {
          onClose();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    return (
      <div ref={pickerRef} className={`absolute z-50 ${positionClass}`}>
        <EmojiPicker
          onEmojiClick={(emojiData) => {
            onEmojiSelect(emojiData.emoji);
            onClose();
          }}
          width={300}
          height={350}
        />
      </div>
    );
  };

  useEffect(() => {
    if (!imageModalData) return;
    const handleKeyDown = (e) => {
      switch (e.key) {
        case "ArrowLeft":
          prevImage();
          break;
        case "ArrowRight":
          nextImage();
          break;
        case "Escape":
          closeImageModal();
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [imageModalData, currentImageIndex]);

  const openImageModal = (files, index = 0) => {
    console.log(files);
    setImageModalData(files);
    setCurrentImageIndex(index);
  };

  const closeImageModal = () => {
    setImageModalData(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % imageModalData.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + imageModalData.length) % imageModalData.length
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOptions &&
        optionsRef.current &&
        buttonRef.current &&
        !optionsRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };
    if (showOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions]);

  useEffect(() => {
    const id = Cookies.get("userId");
    getPosts();
    getProfileData(id);
  }, []);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  const getProfileData = async (id) => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `users`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setIntroFormData(response.data.data);
      setCurrentUser({
        profile_image: response.data.data.profile_image,
        name: response.data.data.name,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getPosts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + "getposts", {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      const fetchedPosts = response.data.data;
      const comments = response.data.data.map((post) => post.comments);

      setPostdata(response.data.data);
      setPost(response.data.data[0]);

      const initialLikes = {};
      const initialLikedStatus = {};
      const initialcommentLikes = {};
      const initialcommentLikedStatus = {};
      const initialComments = {};
      const initialisSaved = {};

      fetchedPosts.forEach((post) => {
        initialLikes[post.id] = post.likes;
        initialLikedStatus[post.id] = post.has_liked;
        initialComments[post.id] = post.comments;
        initialisSaved[post.id] = post.is_saved;
      });

      comments.forEach((comment) => {
        comment.forEach((comment) => {
          initialcommentLikes[comment.comment_id] = comment.comment_likes;
          initialcommentLikedStatus[comment.comment_id] =
            comment.has_liked_comment;
        });
      });

      setInitialLikes(initialLikes);
      setLikes(initialLikes);
      setLikedPosts(initialLikedStatus);
      setRecievedComments(initialComments);
      setCommentLikes(initialcommentLikes);
      setCommentLikedPosts(initialcommentLikedStatus);
      setIsSaved(initialisSaved);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLike = async (postId) => {
    try {
      const prevLiked = likedPosts[postId];
      const prevLikes = likes[postId];

      setLikedPosts((prev) => ({ ...prev, [postId]: !prev[postId] }));
      setLikes((prev) => ({
        ...prev,
        [postId]: prevLiked ? prev[postId] - 1 : prev[postId] + 1,
      }));

      const endpoint = prevLiked
        ? `unlikepost/${postId}`
        : `likepost/${postId}`;

      const response = await axios.post(
        BaseUrl + endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error updating like:", error);
      swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update like status",
      });
    }
  };
  const handleCommentLike = async (commentId, id) => {
    if (!commentlikedPosts[commentId]) {
      setCommentLikedPosts((prevLiked) => ({
        ...prevLiked,
        [commentId]: !prevLiked[commentId],
      }));

      setCommentLikes((prevLikes) => ({
        ...prevLikes,
        [commentId]: commentlikedPosts[commentId]
          ? prevLikes[commentId] - 1
          : prevLikes[commentId] + 1,
      }));
      const response = await axios.post(
        BaseUrl + `likecomment/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        getPosts();
      }
    } else {
      setCommentLikedPosts((prevLiked) => ({
        ...prevLiked,
        [commentId]: !prevLiked[commentId],
      }));

      setCommentLikes((prevLikes) => ({
        ...prevLikes,
        [commentId]: commentlikedPosts[commentId]
          ? prevLikes[commentId] - 1
          : prevLikes[commentId] + 1,
      }));
      const response = await axios.post(
        BaseUrl + `unlikecomment/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        getPosts();
      }
    }
  };

  const handleShowComments = (index) => {
    setShowComments((prevShow) => ({
      ...prevShow,
      [index]: !prevShow[index],
    }));
  };

  const handleCommentSubmit = async (e, postId) => {
    e.preventDefault();
    const commentText = newComments[postId]?.trim();

    if (!commentText) return;

    const formData = new FormData();
    formData.append("comment", commentText);

    try {
      const response = await axios.post(
        BaseUrl + `comment/${postId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setComments((prev) => ({
          ...prev,
          [postId]: [...(prev[postId] || []), response.data.data],
        }));
        setNewComments((prev) => ({
          ...prev,
          [postId]: "",
        }));
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  const handleReplySubmit = async (e, comment_id, post_id) => {
    e.preventDefault();
    if (!replyText.trim()) return;
    const formData = new FormData();
    formData.append("comment", replyText);
    try {
      const response = await axios.post(
        BaseUrl + `commentreply/${post_id}/${comment_id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setReplyingTo(null);
        setReplyText("");
      }
    } catch (error) {
      console.log("Error submitting comment:", error);
    }
  };

  const handleDeletePost = async (postId) => {
    try {
      const response = await axios.post(
        BaseUrl + `deletepost/${postId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setShowOptions(false);
        swal.fire({
          toast: true,
          position: "bottom-start",
          icon: "success",
          title: "Your post has been deleted.",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        getPosts();
      }
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)}h ago`;
    return `${Math.floor(diffInSeconds / 86400)}d ago`;
  };

  const handleToggleSaveUnsave = async (id, type) => {
    console.log(isSaved[id], "before");
    setIsSaved((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
    console.log(isSaved[id], "after");
    setShowOptions(false);
    if (isSaved[id]) {
      await axios.post(
        `${BaseUrl}unsavepost`,
        {
          saved_type: type === "normal" ? "post" : "event",
          savable_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    } else {
      await axios.post(
        `${BaseUrl}savepost`,
        {
          saved_type: type === "normal" ? "post" : "event",
          savable_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-10">
          <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
            <div className="w-full lg:w-1/4 ">
              <div className="bg-white rounded-lg shadow p-4">
                <div className="bg-blue-500 rounded-lg h-16 p-4">
                  <img
                    className="w-24 h-24 rounded-full mx-auto border-4 border-white"
                    src="/Images/newsfeed/CardProfilePicture.png"
                    alt="User avatar"
                  />
                </div>
                <div className="text-center p-4 mt-9">
                  <h2 className="text-xl font-semibold">User Admin</h2>
                  <p className="text-gray-600">
                    Graphic and video editor at LSS pvt.ltd
                  </p>
                </div>
                <div className="border-t">
                  <div className="p-4 flex flex-col gap-4">
                    <div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">Connection</span>
                        <span className="text-blue-500">51</span>
                      </div>
                      <p className="text-gray-800 font-semibold">
                        Grow your network
                      </p>
                    </div>
                    <div className="flex justify-between items-center ">
                      <span className="text-gray-600">Profile Viewers</span>
                      <span className="text-blue-500">04</span>
                    </div>
                  </div>
                  <div className="p-4 border-t">
                    <p className="text-gray-600">Achieve your career goals</p>
                    <button className="mt-2 w-full bg-yellow-500 text-white py-2 rounded-lg">
                      Try Premium Now
                    </button>
                  </div>
                  <div className="p-4 border-t flex items-center">
                    <i className="fas fa-bookmark text-gray-600 mr-2"></i>
                    <span className="text-gray-600">Saved Posts</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-2/4 ">
              <div className="flex flex-col  bg-white w-full border border-gray-300 rounded-md pb-4">
                <div className="flex justify-between items-center px-4 bg-blue-500 py-4 rounded-t-md">
                  <div className="flex space-x-6 ">
                    <div className="text-2xl">
                      <Link to={"/user/userprofile"}>
                        <FaArrowLeftLong />
                      </Link>
                    </div>
                    <div>
                      <p className="text-xl">All Activity</p>
                    </div>
                  </div>
                </div>
                <div className="">
                  {postdata ? (
                    <div className="bg-gray-100">
                      <div className="bg-white">
                        {postdata.map((postdata, postIndex) => (
                          <div
                            key={postIndex}
                            className="mt-4 mx-2 border border-gray-200 rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow duration-200"
                          >
                            <div className="relative flex items-start justify-between space-x-3 px-4 py-2">
                              <div className="flex items-center space-x-3">
                                <div className="w-10 h-10 rounded-full overflow-hidden">
                                  {postdata.user_profile ? (
                                    <img
                                      src={introformData.profile_image}
                                      alt={introformData.name}
                                      className="w-full h-full object-cover border border-gray-200 rounded-full"
                                    />
                                  ) : (
                                    <div className="w-full h-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg">
                                      {introformData.name
                                        .charAt(0)
                                        .toUpperCase()}
                                    </div>
                                  )}
                                </div>
                                <div>
                                  <h3 className="font-semibold">
                                    {introformData.name}
                                  </h3>
                                  <p className="text-xs text-gray-500">
                                    {formatDate(postdata.created_at)}
                                    <span className="mx-1">•</span>
                                    <span>
                                      {postdata.type === "event"
                                        ? "Event"
                                        : "Post"}
                                    </span>
                                  </p>
                                </div>
                              </div>

                              <PiDotsThree
                                className="text-2xl cursor-pointer hover:text-gray-700"
                                onClick={() => {
                                  setShowOptions(!showOptions);
                                  setSelectedIndex(postIndex);
                                }}
                                ref={buttonRef}
                              />

                              {showOptions && postIndex === selectedIndex && (
                                <div
                                  ref={optionsRef}
                                  className="absolute bg-white border border-gray-300 shadow-lg rounded-lg z-50 mt-5 w-72 right-1 overflow-hidden"
                                >
                                  <button
                                    className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
                                    onClick={() => {
                                      handleToggleSaveUnsave(
                                        postdata.id,
                                        postdata.type
                                      );
                                    }}
                                  >
                                    {isSaved[postdata.id] ? (
                                      <FaBookmark />
                                    ) : (
                                      <FaRegBookmark />
                                    )}
                                    {isSaved[postdata.id] ? "Unsave" : "Save"}
                                  </button>

                                  <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
                                    <FaLink />
                                    Copy Link to Post
                                  </button>

                                  <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
                                    <FaEdit />
                                    Edit Post
                                  </button>

                                  <button
                                    className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
                                    onClick={(e) => {
                                      handleDeletePost(postdata.id);
                                    }}
                                  >
                                    <FaTrash />
                                    Delete Post
                                  </button>

                                  <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
                                    <FaCommentSlash />
                                    Disable Comments on this Post
                                  </button>
                                </div>
                              )}
                            </div>

                            {postdata.type === "event" ? (
                              <div className="px-4 py-2">
                                <div className="w-full bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 ">
                                  {postdata.media && (
                                    <div className="">
                                      <img
                                        src={
                                          postdata.media.url ||
                                          "/Images/cover-img.jpg "
                                        }
                                        alt="Event Preview"
                                        className="w-full h-full object-cover"
                                      />
                                    </div>
                                  )}
                                  <div className="flex justify-between p-4 bg-white">
                                    <div>
                                      <p className="text-sm text-orange-600 font-semibold">
                                        {postdata.event.time}
                                      </p>
                                      <h2 className="text-lg font-bold text-gray-900 mt-1">
                                        {postdata.event.event_name}
                                      </h2>
                                      <p className="text-sm text-gray-600">
                                        Event by {postdata.event.organizer}
                                      </p>
                                      <p className="text-sm text-gray-600">
                                        {postdata.event.event_type === "online"
                                          ? postdata.event.event_type
                                          : postdata.event.address}
                                      </p>
                                    </div>
                                    <Link
                                      to={`/events/${postdata.event.slug}`}
                                      className="flex items-center  h-8 px-4 text-blue-600 border border-blue-600 rounded-full hover:bg-blue-100"
                                    >
                                      View event
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div>
                                <p className="text-[15px] px-4 pb-2 text-gray-800 leading-snug whitespace-pre-line">
                                  {postdata.content}
                                </p>

                                <div
                                  className={`grid gap-1 overflow-hidden ${
                                    postdata.media.length === 1
                                      ? "grid-cols-1 min-h-[250px]"
                                      : "grid-cols-2 min-h-[250px]"
                                  }`}
                                >
                                  {postdata.media
                                    .slice(0, 4)
                                    .map((image, index) => (
                                      <div
                                        key={index}
                                        className={`relative group cursor-pointer flex justify-center ${
                                          postdata.media.length === 3 &&
                                          index === 0
                                            ? "col-span-2"
                                            : ""
                                        }`}
                                        onClick={() => {
                                          openImageModal(postdata.media, index);
                                        }}
                                      >
                                        <img
                                          src={image.url}
                                          alt={`preview-${index}`}
                                          className="h-full w-full object-cover"
                                        />
                                        {index === 3 &&
                                          postdata.media.length > 4 && (
                                            <div className="absolute inset-0 flex items-center justify-center bg-black/40 text-white font-bold text-2xl">
                                              +{postdata.media.length - 4}
                                            </div>
                                          )}
                                      </div>
                                    ))}
                                </div>

                                {imageModalData && (
                                  <div
                                    className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fade-in"
                                    tabIndex={-1}
                                  >
                                    <div className="relative bg-white rounded-xl shadow-2xl overflow-hidden w-[1000px] flex flex-col transition-all duration-300">
                                      {/* Top Header Section */}
                                      <div className="w-full flex justify-end p-4 border-b border-gray-200 bg-white z-10">
                                        <button
                                          onClick={closeImageModal}
                                          className="bg-white hover:bg-gray-100 text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-transform duration-200 hover:scale-110"
                                          title="Close"
                                        >
                                          <i className="fas fa-times text-xl"></i>
                                        </button>
                                      </div>

                                      {/* Fixed Size Image/Video Container */}
                                      <div className="relative w-full h-[600px] bg-black flex items-center justify-center">
                                        {imageModalData[currentImageIndex]
                                          .type === "image" ? (
                                          <img
                                            src={
                                              imageModalData[currentImageIndex]
                                                .url
                                            }
                                            alt={
                                              imageModalData[currentImageIndex]
                                                .name
                                            }
                                            className="w-full h-full object-contain"
                                          />
                                        ) : (
                                          <video
                                            src={
                                              imageModalData[currentImageIndex]
                                                .url
                                            }
                                            controls
                                            className="w-full h-full object-contain"
                                          />
                                        )}

                                        {/* Navigation Buttons */}
                                        {imageModalData.length > 1 && (
                                          <>
                                            <button
                                              onClick={prevImage}
                                              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white hover:bg-gray-100 text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-transform duration-200 hover:scale-110"
                                              title="Previous"
                                            >
                                              <i className="fas fa-chevron-left text-xl"></i>
                                            </button>
                                            <button
                                              onClick={nextImage}
                                              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white hover:bg-gray-100 text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md transition-transform duration-200 hover:scale-110"
                                              title="Next"
                                            >
                                              <i className="fas fa-chevron-right text-xl"></i>
                                            </button>

                                            {/* Counter */}
                                            <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 bg-white px-3 py-1 rounded-full shadow text-sm text-gray-700">
                                              {currentImageIndex + 1} /{" "}
                                              {imageModalData.length}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            <div className="flex justify-between items-center px-4 py-2 border-t border-gray-100">
                              <button
                                onClick={() => handleLike(postdata.id)}
                                className="flex items-center space-x-1 text-gray-500 hover:text-red-500 px-3 py-1.5 rounded-md hover:bg-gray-50"
                              >
                                {likedPosts[postdata.id] ? (
                                  <FaHeart className="text-red-500" />
                                ) : (
                                  <FaRegHeart />
                                )}
                                <span className="text-sm">
                                  {likes[postdata.id] || 0}
                                </span>
                              </button>

                              <button
                                onClick={() => handleShowComments(postIndex)}
                                className="flex items-center space-x-1 text-gray-500 hover:text-blue-500 px-3 py-1.5 rounded-md hover:bg-gray-50"
                              >
                                <FaRegComment />
                                <span className="text-sm">
                                  {recievedcomments[postdata.id].length}
                                </span>
                              </button>

                              <button className="flex items-center space-x-1 text-gray-500 hover:text-green-500 px-3 py-1.5 rounded-md hover:bg-gray-50">
                                <FaRegShareSquare />
                                <span className="text-sm">Share</span>
                              </button>
                            </div>

                            {showComments[postIndex] && (
                              <div className="px-4 pb-3 bg-gray-50 rounded-b-lg">
                                <form
                                  onSubmit={(e) =>
                                    handleCommentSubmit(e, postdata.id)
                                  }
                                  className="flex items-center gap-2 pt-3"
                                >
                                  <img
                                    src={introformData.profile_image}
                                    className="w-8 h-8 rounded-full"
                                    alt="Your profile"
                                  />
                                  <div className="flex-1 relative">
                                    <input
                                      type="text"
                                      autoFocus
                                      className="w-full p-2 pl-3 pr-10 border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                      placeholder="Write a comment..."
                                      value={newComments[postdata.id] || ""}
                                      onChange={(e) =>
                                        setNewComments((prev) => ({
                                          ...prev,
                                          [postdata.id]: e.target.value,
                                        }))
                                      }
                                    />
                                    <button
                                      type="submit"
                                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-500 hover:text-blue-600"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                </form>

                                <div className="mt-3 space-y-3 max-h-[300px] overflow-y-auto pr-2">
                                  {recievedcomments[postdata.id]
                                    .slice(
                                      0,
                                      showAllComments ? comments.length : 2
                                    )
                                    .map((comment) => (
                                      <div
                                        key={comment.comment_id}
                                        className="flex gap-3"
                                      >
                                        <div className="flex-shrink-0">
                                          {comment.comment_user_profile ? (
                                            <img
                                              src={comment.comment_user_profile}
                                              alt={comment.comment_user_name}
                                              className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                            />
                                          ) : (
                                            <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                              {comment.user_name?.[0]?.toUpperCase()}
                                            </div>
                                          )}
                                        </div>

                                        <div className="flex-1">
                                          <div className="bg-gray-50 rounded-2xl p-3">
                                            <div className="flex items-center justify-between">
                                              <div className="flex items-center gap-1">
                                                <p className="font-medium text-sm text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                                  {comment.comment_user_name ||
                                                    "User"}
                                                </p>
                                                {comment.is_author && (
                                                  <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                                    Author
                                                  </span>
                                                )}
                                              </div>
                                              <span className="text-xs text-gray-500">
                                                {formatTimeAgo(
                                                  comment.created_at
                                                )}
                                              </span>
                                            </div>

                                            <p className="text-sm text-gray-800 mt-1 whitespace-pre-line">
                                              {comment.comment}
                                            </p>

                                            <div className="flex items-center mt-2 text-xs text-gray-500">
                                              <button
                                                className={`flex items-center gap-1 hover:text-blue-600 ${
                                                  comment.has_liked_comment
                                                    ? "text-blue-600"
                                                    : ""
                                                }`}
                                                onClick={() =>
                                                  handleCommentLike(
                                                    comment.has_liked_comment,
                                                    comment.comment_id
                                                  )
                                                }
                                              >
                                                <i
                                                  className={`fas fa-thumbs-up ${
                                                    comment.has_liked_comment
                                                      ? "text-blue-500"
                                                      : ""
                                                  }`}
                                                ></i>
                                                {comment.comment_likes > 0 && (
                                                  <span>
                                                    {comment.comment_likes}
                                                  </span>
                                                )}
                                                <span>Like</span>
                                              </button>

                                              <span className="mx-2 text-gray-800">
                                                |
                                              </span>

                                              <button
                                                className="flex items-center gap-1 hover:text-blue-600"
                                                onClick={() =>
                                                  setReplyingTo(
                                                    replyingTo ===
                                                      comment.comment_id
                                                      ? null
                                                      : comment.comment_id
                                                  )
                                                }
                                              >
                                                <MdReply className="text-base" />
                                                <span className="ml-1">
                                                  Reply
                                                </span>
                                                {comment.replies &&
                                                  comment.replies.length >
                                                    0 && (
                                                    <>
                                                      <span className="mx-1">
                                                        •
                                                      </span>
                                                      <span>
                                                        {comment.replies.length}
                                                      </span>
                                                      {comment.replies
                                                        .length === 1
                                                        ? "reply"
                                                        : "replies"}
                                                    </>
                                                  )}
                                              </button>
                                            </div>
                                          </div>

                                          {comment.replies &&
                                            comment.replies.length > 0 && (
                                              <div className="mt-2 ml-2 pl-4 border-l-2 border-gray-200">
                                                {comment.replies
                                                  .slice(
                                                    0,
                                                    showAllReplies[
                                                      comment.comment_id
                                                    ]
                                                      ? comment.replies.length
                                                      : 2
                                                  )
                                                  .map((reply) => (
                                                    <div
                                                      key={reply.comment_id}
                                                      className="flex gap-3 mt-3"
                                                    >
                                                      <div className="flex-shrink-0">
                                                        {reply.comment_user_profile ? (
                                                          <img
                                                            src={
                                                              reply.comment_user_profile
                                                            }
                                                            alt={
                                                              reply.comment_user_name
                                                            }
                                                            className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                                          />
                                                        ) : (
                                                          <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                                            {reply.user_name?.[0]?.toUpperCase()}
                                                          </div>
                                                        )}
                                                      </div>

                                                      <div className="flex-1">
                                                        <div className="bg-gray-50 rounded-2xl p-3">
                                                          <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-1">
                                                              <p className="font-medium text-sm text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                                                {reply.comment_user_name ||
                                                                  "User"}
                                                              </p>
                                                              {reply.is_author && (
                                                                <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                                                  Author
                                                                </span>
                                                              )}
                                                            </div>
                                                            <span className="text-xs text-gray-500">
                                                              {formatTimeAgo(
                                                                reply.created_at
                                                              )}
                                                            </span>
                                                          </div>

                                                          <p className="text-sm text-gray-800 mt-1">
                                                            {reply.comment}
                                                          </p>

                                                          <div className="flex items-center mt-2 text-xs text-gray-500 space-x-4">
                                                            <button
                                                              className={`flex items-center gap-1 hover:text-blue-600 ${
                                                                reply.has_liked_comment
                                                                  ? "text-blue-600"
                                                                  : ""
                                                              }`}
                                                              onClick={() =>
                                                                handleCommentLike(
                                                                  reply.has_liked_comment,
                                                                  reply.comment_id
                                                                )
                                                              }
                                                            >
                                                              <MdThumbUp className="icon" />
                                                              {reply.comment_likes >
                                                                0 && (
                                                                <span>
                                                                  {
                                                                    reply.comment_likes
                                                                  }
                                                                </span>
                                                              )}
                                                              <span>Like</span>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ))}

                                                {comment.replies.length > 2 && (
                                                  <button
                                                    onClick={() =>
                                                      setShowAllReplies(
                                                        (prev) => ({
                                                          ...prev,
                                                          [comment.comment_id]:
                                                            !prev[
                                                              comment.comment_id
                                                            ],
                                                        })
                                                      )
                                                    }
                                                    className="w-full text-left text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors mt-2"
                                                  >
                                                    <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                                                      {showAllReplies[
                                                        comment.comment_id
                                                      ] ? (
                                                        <>
                                                          <MdKeyboardArrowUp className="mr-1 text-lg" />
                                                          Collapse replies
                                                        </>
                                                      ) : (
                                                        <>
                                                          <MdKeyboardArrowDown className="mr-1 text-lg" />
                                                          See{" "}
                                                          {comment.replies
                                                            .length - 2}{" "}
                                                          more{" "}
                                                          {comment.replies
                                                            .length -
                                                            2 ===
                                                          1
                                                            ? "reply"
                                                            : "replies"}
                                                        </>
                                                      )}
                                                    </div>
                                                  </button>
                                                )}
                                              </div>
                                            )}

                                          {replyingTo ===
                                            comment.comment_id && (
                                            <div className="mt-3 ml-2 pl-4 border-l-2 border-gray-200">
                                              <form
                                                onSubmit={(e) =>
                                                  handleReplySubmit(
                                                    e,
                                                    comment.comment_id,
                                                    comment.comment_post_id
                                                  )
                                                }
                                                className="flex gap-2 items-start"
                                              >
                                                <img
                                                  src={
                                                    currentUser.profileImage ||
                                                    "/default-avatar.png"
                                                  }
                                                  alt="You"
                                                  className="w-8 h-8 rounded-full object-cover border border-gray-200 mt-1"
                                                />
                                                <div className="flex-1 flex flex-col">
                                                  <div className="flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
                                                    <input
                                                      type="text"
                                                      value={replyText}
                                                      onChange={(e) =>
                                                        setReplyText(
                                                          e.target.value
                                                        )
                                                      }
                                                      placeholder="Add a comment..."
                                                      className="flex-1 outline-none bg-transparent"
                                                    />
                                                    <div className="relative flex items-center gap-2">
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          setShowReplyEmojiPicker(
                                                            !showEmojiPicker
                                                          )
                                                        }
                                                        className="text-gray-500 hover:text-gray-700"
                                                      >
                                                        😊
                                                      </button>
                                                      {showReplyEmojiPicker && (
                                                        <EmojiPickerWrapper
                                                          onEmojiSelect={(
                                                            emoji
                                                          ) =>
                                                            setReplyText(
                                                              (prev) =>
                                                                prev + emoji
                                                            )
                                                          }
                                                          onClose={() =>
                                                            setShowReplyEmojiPicker(
                                                              false
                                                            )
                                                          }
                                                          positionClass="absolute bottom-16 right-0"
                                                        />
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="flex justify-end mt-2">
                                                    <button
                                                      type="button"
                                                      onClick={() =>
                                                        setReplyingTo(null)
                                                      }
                                                      className="text-gray-600 text-sm px-3 py-1 rounded-md hover:bg-gray-100 mr-2"
                                                    >
                                                      Cancel
                                                    </button>
                                                    <button
                                                      type="submit"
                                                      disabled={
                                                        !replyText.trim()
                                                      }
                                                      className="bg-blue-600 text-white text-sm px-3 py-1 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                                                    >
                                                      Post
                                                    </button>
                                                  </div>
                                                </div>
                                              </form>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    ))}

                                  {comments.length > 2 && (
                                    <div className="pt-2">
                                      <button
                                        onClick={() =>
                                          setShowAllComments(!showAllComments)
                                        }
                                        className="w-full text-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
                                      >
                                        <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                                          {showAllComments ? (
                                            <>
                                              <MdKeyboardArrowUp className="mr-1 text-lg" />
                                              Show fewer comments
                                            </>
                                          ) : (
                                            <>
                                              <MdKeyboardArrowDown className="mr-1 text-lg" />
                                              Show {comments.length - 2} more{" "}
                                              {comments.length - 2 === 1
                                                ? "comment"
                                                : "comments"}
                                            </>
                                          )}
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="px-4">
                      <p className="text-gray-700 font-semibold mb-1">
                        You haven’t posted yet
                      </p>
                      <p className="text-gray-500 text-sm mb-4">
                        Posts you share will be displayed here.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/4">
              <div className="bg-white w-full border border-gray-300 rounded-md">
                <img
                  src="https://placehold.co/200x200"
                  alt="Profile picture"
                  className="w-full h-48 object-cover rounded-t-md"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default EditPost;

{
  /* <div className="">
                  {postdata ? (
                    <div className="bg-gray-100">
                      <div className="bg-white ">
                        {postdata.map((postdata, postIndex) => (
                          <div
                            key={postIndex}
                            className="mt-4 mx-2  border border-gray-200 rounded-lg   bg-white shadow-sm hover:shadow-md transition-shadow duration-200"
                          >
                            <div className="relative flex items-start justify-between space-x-3 px-4 py-2">
                              <div className="flex items-center space-x-3">
                                <div className="w-10 h-10 rounded-full overflow-hidden">
                                  {post.user_profile ? (
                                    <img
                                      src={introformData.profile_image}
                                      alt={introformData.name}
                                      className="w-full h-full object-cover border border-gray-200 rounded-full"
                                    />
                                  ) : (
                                    <div className="w-full h-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg">
                                      {introformData.name
                                        .charAt(0)
                                        .toUpperCase()}
                                    </div>
                                  )}
                                </div>
                                <div>
                                  <h3 className="font-semibold">
                                    {introformData.name}
                                  </h3>
                                  <p className="text-xs text-gray-500">
                                    {formatDate(postdata.created_at)}
                                    <span className="mx-1">•</span>
                                    <span>Post</span>
                                  </p>
                                </div>
                              </div>

                              <PiDotsThree
                                className="text-2xl cursor-pointer hover:text-gray-700"
                                onClick={() => {
                                  setShowOptions(!showOptions);
                                  setSelectedIndex(postIndex);
                                }}
                                ref={buttonRef}
                              />

                              {showOptions && postIndex === selectedIndex && (
                                <div
                                  ref={optionsRef}
                                  className="absolute bg-white border border-gray-300 shadow-lg rounded-lg z-50 mt-5 w-72 right-1 overflow-hidden"
                                >
                                  <button
                                    className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
                                    onClick={()=>{handleToggleSaveUnsave(postdata.id)}}
                                  >
                                    {isSaved[postdata.id] ? (
                                      <FaBookmark />
                                    ) : (
                                      <FaRegBookmark />
                                    )}
                                    {isSaved[postdata.id] ? "Unsave" : "Save"}
                                  </button>

                                  <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
                                    <FaLink />
                                    Copy Link to Post
                                  </button>

                                  <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
                                    <FaEdit />
                                    Edit Post
                                  </button>

                                  <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
                                    onClick={(e)=>{handleDeletePost(postdata.id)}}

                                  >
                                    <FaTrash />
                                    Delete Post
                                  </button>

                                  <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
                                    <FaCommentSlash />
                                    Disable Comments on this Post
                                  </button>
                                </div>
                              )}
                            </div>

                            <p className="text-[15px] px-4 pb-2 text-gray-800 leading-snug whitespace-pre-line">
                              {postdata.content}
                            </p>

                            <div
                              className={`grid gap-1 overflow-hidden ${
                                postdata.media.length === 1
                                  ? "grid-cols-1 min-h-[250px]"
                                  : "grid-cols-2 min-h-[250px]"
                              }`}
                            >
                              {postdata.media
                                .slice(0, 4)
                                .map((image, index) => (
                                  <div
                                    key={index}
                                    className={`relative group cursor-pointer flex justify-center ${
                                      postdata.media.length === 3 && index === 0
                                        ? "col-span-2"
                                        : ""
                                    }`}
                                    onClick={() => {
                                      setLightboxImages(postdata.media);
                                      setSelectedImageIndex(index);
                                      setShowLightbox(true);
                                    }}
                                  >
                                    <img
                                      src={image.url}
                                      alt={`preview-${index}`}
                                      className="h-full w-full object-cover"
                                    />
                                    {index === 3 &&
                                      postdata.media.length > 4 && (
                                        <div className="absolute inset-0 flex items-center justify-center bg-black/40 text-white font-bold text-2xl">
                                          +{postdata.media.length - 4}
                                        </div>
                                      )}
                                  </div>
                                ))}
                            </div>

                            {showLightbox && selectedImageIndex !== null && (
                              <div className="fixed inset-0 flex items-center justify-center bg-black/90 z-[100] backdrop-blur-sm">
                                <div className="relative w-full h-full max-w-6xl max-h-[90vh] flex flex-col">
                                  <div className="flex justify-between items-center bg-black/50 text-white">
                                    <div className="text-sm text-gray-300">
                                      {selectedImageIndex + 1} /{" "}
                                      {lightboxImages.length}
                                    </div>
                                    <button
                                      className="p-2 rounded-full hover:bg-white/10 transition-colors"
                                      onClick={() => setShowLightbox(false)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M6 18L18 6M6 6l12 12"
                                        />
                                      </svg>
                                    </button>
                                  </div>

                                  <div className="flex-1 relative flex items-center justify-center ">
                                    {selectedImageIndex > 0 && (
                                      <button
                                        className="absolute left-4 md:left-8 p-3 rounded-full bg-black/50 text-white hover:bg-black/70 transition-all z-10"
                                        onClick={() =>
                                          setSelectedImageIndex(
                                            (prev) => prev - 1
                                          )
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-8 w-8"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke="currentColor"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 19l-7-7 7-7"
                                          />
                                        </svg>
                                      </button>
                                    )}

                                    <div className="w-full h-full flex items-center justify-center">
                                      <img
                                        src={
                                          lightboxImages[selectedImageIndex].url
                                        }
                                        alt={`media-${selectedImageIndex}`}
                                        className="max-w-full max-h-full object-contain rounded-md"
                                        style={{
                                          cursor:
                                            lightboxImages.length > 1
                                              ? "pointer"
                                              : "default",
                                        }}
                                        onClick={() => {
                                          if (lightboxImages.length > 1) {
                                            setSelectedImageIndex((prev) =>
                                              prev === lightboxImages.length - 1
                                                ? 0
                                                : prev + 1
                                            );
                                          }
                                        }}
                                      />
                                    </div>

                                    {selectedImageIndex <
                                      lightboxImages.length - 1 && (
                                      <button
                                        className="absolute right-4 md:right-8 p-3 rounded-full bg-black/50 text-white hover:bg-black/70 transition-all z-10"
                                        onClick={() =>
                                          setSelectedImageIndex(
                                            (prev) => prev + 1
                                          )
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-8 w-8"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke="currentColor"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                          />
                                        </svg>
                                      </button>
                                    )}
                                  </div>

                                  {lightboxImages.length > 1 && (
                                    <div className="p-4 bg-black/50 flex justify-center overflow-x-auto">
                                      <div className="flex space-x-2">
                                        {lightboxImages.map((image, index) => (
                                          <div
                                            key={index}
                                            className={`w-16 h-16 rounded-md overflow-hidden cursor-pointer border-2 transition-all ${
                                              selectedImageIndex === index
                                                ? "border-blue-500"
                                                : "border-transparent"
                                            }`}
                                            onClick={() =>
                                              setSelectedImageIndex(index)
                                            }
                                          >
                                            <img
                                              src={image.url}
                                              alt={`thumbnail-${index}`}
                                              className="w-full h-full object-cover"
                                            />
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                            <div className="flex justify-between items-center px-4 py-2 border-t border-gray-100">
                              <button
                                onClick={() => handleLike(postdata.id)}
                                className="flex items-center space-x-1 text-gray-500 hover:text-red-500 px-3 py-1.5 rounded-md hover:bg-gray-50"
                              >
                                {likedPosts[postdata.id] ? (
                                  <FaHeart className="text-red-500" />
                                ) : (
                                  <FaRegHeart />
                                )}
                                <span className="text-sm">
                                  {likes[postdata.id] || 0}
                                </span>
                              </button>

                              <button
                                onClick={() => handleShowComments(postIndex)}
                                className="flex items-center space-x-1 text-gray-500 hover:text-blue-500 px-3 py-1.5 rounded-md hover:bg-gray-50"
                              >
                                <FaRegComment />
                                <span className="text-sm">
                                  {recievedcomments[postdata.id].length}
                                </span>
                              </button>

                              <button className="flex items-center space-x-1 text-gray-500 hover:text-green-500 px-3 py-1.5 rounded-md hover:bg-gray-50">
                                <FaRegShareSquare />
                                <span className="text-sm">Share</span>
                              </button>
                            </div>
                            {showComments[postIndex] && (
                              <div className="px-4 pb-3 bg-gray-50 rounded-b-lg">
                                <form
                                  onSubmit={(e) =>
                                    handleCommentSubmit(e, postdata.id)
                                  }
                                  className="flex items-center gap-2 pt-3"
                                >
                                  <img
                                    src={introformData.profile_image}
                                    className="w-8 h-8 rounded-full"
                                    alt="Your profile"
                                  />
                                  <div className="flex-1 relative">
                                    <input
                                      type="text"
                                      autoFocus
                                      className="w-full p-2 pl-3 pr-10 border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                      placeholder="Write a comment..."
                                      value={newComments[postdata.id] || ""}
                                      onChange={(e) =>
                                        setNewComments((prev) => ({
                                          ...prev,
                                          [postdata.id]: e.target.value,
                                        }))
                                      }
                                    />
                                    <button
                                      type="submit"
                                      className="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-500 hover:text-blue-600"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                </form>

                                <div className="mt-3 space-y-3 max-h-[300px] overflow-y-auto pr-2">
                                  {recievedcomments[postdata.id]
                                    .slice(
                                      0,
                                      showAllComments ? comments.length : 2
                                    )
                                    .map((comment) => (
                                      <div
                                        key={comment.comment_id}
                                        className="flex gap-3"
                                      >
                                        <div className="flex-shrink-0">
                                          {comment.comment_user_profile ? (
                                            <img
                                              src={comment.comment_user_profile}
                                              alt={comment.comment_user_name}
                                              className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                            />
                                          ) : (
                                            <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                              {comment.user_name?.[0]?.toUpperCase()}
                                            </div>
                                          )}
                                        </div>

                                        <div className="flex-1">
                                          <div className="bg-gray-50 rounded-2xl p-3">
                                            <div className="flex items-center justify-between">
                                              <div className="flex items-center gap-1">
                                                <p className="font-medium text-sm text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                                  {comment.comment_user_name ||
                                                    "User"}
                                                </p>
                                                {comment.is_author && (
                                                  <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                                    Author
                                                  </span>
                                                )}
                                              </div>
                                              <span className="text-xs text-gray-500">
                                                {formatTimeAgo(
                                                  comment.created_at
                                                )}
                                              </span>
                                            </div>

                                            <p className="text-sm text-gray-800 mt-1 whitespace-pre-line">
                                              {comment.comment}
                                            </p>

                                            <div className="flex items-center mt-2 text-xs text-gray-500">
                                              <button
                                                className={`flex items-center gap-1 hover:text-blue-600 ${
                                                  comment.has_liked_comment
                                                    ? "text-blue-600"
                                                    : ""
                                                }`}
                                                onClick={() =>
                                                  handleCommentLike(
                                                    comment.has_liked_comment,
                                                    comment.comment_id
                                                  )
                                                }
                                              >
                                                <i
                                                  className={`fas fa-thumbs-up ${
                                                    comment.has_liked_comment
                                                      ? "text-blue-500"
                                                      : ""
                                                  }`}
                                                ></i>
                                                {comment.comment_likes > 0 && (
                                                  <span>
                                                    {comment.comment_likes}
                                                  </span>
                                                )}
                                                <span>Like</span>
                                              </button>

                                              <span className="mx-2 text-gray-800">
                                                |
                                              </span>

                                              
                                              <button
                                                className="flex items-center gap-1 hover:text-blue-600"
                                                onClick={() =>
                                                  setReplyingTo(
                                                    replyingTo ===
                                                      comment.comment_id
                                                      ? null
                                                      : comment.comment_id
                                                  )
                                                }
                                              >
                                                <MdReply className="text-base" />
                                                <span className="ml-1">
                                                  Reply
                                                </span>
                                                {comment.replies &&
                                                  comment.replies.length >
                                                    0 && (
                                                    <>
                                                      <span className="mx-1">
                                                        •
                                                      </span>
                                                      <span>
                                                        {comment.replies.length}
                                                      </span>
                                                      {comment.replies
                                                        .length === 1
                                                        ? "reply"
                                                        : "replies"}
                                                    </>
                                                  )}
                                              </button>
                                            </div>
                                          </div>

                                          
                                          {comment.replies &&
                                            comment.replies.length > 0 && (
                                              <div className="mt-2 ml-2 pl-4 border-l-2 border-gray-200">
                                                {comment.replies
                                                  .slice(
                                                    0,
                                                    showAllReplies[
                                                      comment.comment_id
                                                    ]
                                                      ? comment.replies.length
                                                      : 2
                                                  )
                                                  .map((reply) => (
                                                    <div
                                                      key={reply.comment_id}
                                                      className="flex gap-3 mt-3"
                                                    >
                                                      <div className="flex-shrink-0">
                                                        {reply.comment_user_profile ? (
                                                          <img
                                                            src={
                                                              reply.comment_user_profile
                                                            }
                                                            alt={
                                                              reply.comment_user_name
                                                            }
                                                            className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                                          />
                                                        ) : (
                                                          <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                                            {reply.user_name?.[0]?.toUpperCase()}
                                                          </div>
                                                        )}
                                                      </div>

                                                      <div className="flex-1">
                                                        <div className="bg-gray-50 rounded-2xl p-3">
                                                          <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-1">
                                                              <p className="font-medium text-sm text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                                                {reply.comment_user_name ||
                                                                  "User"}
                                                              </p>
                                                              {reply.is_author && (
                                                                <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                                                  Author
                                                                </span>
                                                              )}
                                                            </div>
                                                            <span className="text-xs text-gray-500">
                                                              {formatTimeAgo(
                                                                reply.created_at
                                                              )}
                                                            </span>
                                                          </div>

                                                          <p className="text-sm text-gray-800 mt-1">
                                                            {reply.comment}
                                                          </p>

                                                          <div className="flex items-center mt-2 text-xs text-gray-500 space-x-4">
                                                            <button
                                                              className={`flex items-center gap-1 hover:text-blue-600 ${
                                                                reply.has_liked_comment
                                                                  ? "text-blue-600"
                                                                  : ""
                                                              }`}
                                                              onClick={() =>
                                                                handleCommentLike(
                                                                  reply.has_liked_comment,
                                                                  reply.comment_id
                                                                )
                                                              }
                                                            >
                                                              <MdThumbUp className="icon" />
                                                              {reply.comment_likes >
                                                                0 && (
                                                                <span>
                                                                  {
                                                                    reply.comment_likes
                                                                  }
                                                                </span>
                                                              )}
                                                              <span>Like</span>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ))}

                                                {comment.replies.length > 2 && (
                                                  <button
                                                    onClick={() =>
                                                      setShowAllReplies(
                                                        (prev) => ({
                                                          ...prev,
                                                          [comment.comment_id]:
                                                            !prev[
                                                              comment.comment_id
                                                            ],
                                                        })
                                                      )
                                                    }
                                                    className="w-full text-left text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors mt-2"
                                                  >
                                                    <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                                                      {showAllReplies[
                                                        comment.comment_id
                                                      ] ? (
                                                        <>
                                                          <MdKeyboardArrowUp className="mr-1 text-lg" />
                                                          Collapse replies
                                                        </>
                                                      ) : (
                                                        <>
                                                          <MdKeyboardArrowDown className="mr-1 text-lg" />
                                                          See{" "}
                                                          {comment.replies
                                                            .length - 2}{" "}
                                                          more{" "}
                                                          {comment.replies
                                                            .length -
                                                            2 ===
                                                          1
                                                            ? "reply"
                                                            : "replies"}
                                                        </>
                                                      )}
                                                    </div>
                                                  </button>
                                                )}
                                              </div>
                                            )}
                                          
                                          {replyingTo ===
                                            comment.comment_id && (
                                            <div className="mt-3 ml-2 pl-4 border-l-2 border-gray-200">
                                              <form
                                                onSubmit={(e) =>
                                                  handleReplySubmit(
                                                    e,
                                                    comment.comment_id
                                                  )
                                                }
                                                className="flex gap-2 items-start"
                                              >
                                                <img
                                                  src={
                                                    currentUser.profileImage ||
                                                    "/default-avatar.png"
                                                  }
                                                  alt="You"
                                                  className="w-8 h-8 rounded-full object-cover border border-gray-200 mt-1"
                                                />
                                                <div className="flex-1 flex flex-col">
                                                  <div className="flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
                                                    <input
                                                      type="text"
                                                      value={replyText}
                                                      onChange={(e) =>
                                                        setReplyText(
                                                          e.target.value
                                                        )
                                                      }
                                                      placeholder="Add a comment..."
                                                      className="flex-1 outline-none bg-transparent"
                                                    />
                                                    <div className="relative flex items-center gap-2">
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          setShowReplyEmojiPicker(
                                                            !showEmojiPicker
                                                          )
                                                        }
                                                        className="text-gray-500 hover:text-gray-700"
                                                      >
                                                        😊
                                                      </button>
                                                      {showReplyEmojiPicker && (
                                                        <EmojiPickerWrapper
                                                          onEmojiSelect={(
                                                            emoji
                                                          ) =>
                                                            setReplyText(
                                                              (prev) =>
                                                                prev + emoji
                                                            )
                                                          }
                                                          onClose={() =>
                                                            setShowReplyEmojiPicker(
                                                              false
                                                            )
                                                          }
                                                          positionClass="absolute bottom-16 right-0"
                                                        />
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="flex justify-end mt-2">
                                                    <button
                                                      type="button"
                                                      onClick={() =>
                                                        setReplyingTo(null)
                                                      }
                                                      className="text-gray-600 text-sm px-3 py-1 rounded-md hover:bg-gray-100 mr-2"
                                                    >
                                                      Cancel
                                                    </button>
                                                    <button
                                                      type="submit"
                                                      disabled={
                                                        !replyText.trim()
                                                      }
                                                      className="bg-blue-600 text-white text-sm px-3 py-1 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                                                    >
                                                      Post
                                                    </button>
                                                  </div>
                                                </div>
                                              </form>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    ))}

                                  {comments.length > 2 && (
                                    <div className="pt-2">
                                      <button
                                        onClick={() =>
                                          setShowAllComments(!showAllComments)
                                        }
                                        className="w-full text-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
                                      >
                                        <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                                          {showAllComments ? (
                                            <>
                                              <MdKeyboardArrowUp className="mr-1 text-lg" />
                                              Show fewer comments
                                            </>
                                          ) : (
                                            <>
                                              <MdKeyboardArrowDown className="mr-1 text-lg" />
                                              Show {comments.length - 2} more{" "}
                                              {comments.length - 2 === 1
                                                ? "comment"
                                                : "comments"}
                                            </>
                                          )}
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="px-4">
                      <p className="text-gray-700 font-semibold mb-1">
                        You haven’t posted yet
                      </p>
                      <p className="text-gray-500 text-sm mb-4">
                        Posts you share will be displayed here.
                      </p>
                    </div>
                  )}
                </div> */
}
